// angular imports
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

// local imports
import {
  SecurityConfig,
  AppAvailabilityDto,
  GetUserNotificationResponseDto,
} from "@app/core";
import { ApiConstants, HttpResult, PollyHttpHelper } from "@app/shared";

@Injectable({
  providedIn: "root",
})
export class AppDataHttpService {
  constructor(
    private http: HttpClient,
    private applicationConfig: SecurityConfig,
  ) {}

  getApps(): HttpResult<AppAvailabilityDto> {
    let serviceUri = `${this.applicationConfig.applicationUri}/v2/user/apps`;

    console.log(`GET: ${serviceUri}`);

    return PollyHttpHelper.Invoke("GET", () =>
      this.http.get<AppAvailabilityDto>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }

  public getUserNotifications(): HttpResult<GetUserNotificationResponseDto> 
  {      
    let serviceUri = `${this.applicationConfig.applicationUri}/v2/notification`;

    console.log(`GET: ${serviceUri}`);

    return PollyHttpHelper.Invoke("GET", () =>
      this.http.get<GetUserNotificationResponseDto>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }

  public deleteNotification(notificationId: string): HttpResult<Object> {
    let serviceUri = `${this.applicationConfig.applicationUri}/v2/notification/${notificationId}`;

    console.log(`DELETE: ${serviceUri}`);

    return PollyHttpHelper.Invoke("DELETE", () =>
      this.http.delete<Object>(serviceUri, {
        headers: ApiConstants.DefaultHeaders,
      }),
    );
  }
}